var React = require('react');

function BrowseFasterIcon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#cxrdmparla)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11 22H4.099C5.037 12.551 12.55 5.037 22 4.099V11h4V4.099C35.449 5.037 42.963 12.55 43.901 22H37v4h6.901C42.898 36.107 34.371 44 24 44 13.63 44 5.102 36.107 4.099 26H11v-4zm36.918 4C46.902 38.32 36.58 48 24 48S1.098 38.32.082 26H0v-4h.082C1.044 10.34 10.34 1.044 22 .082V0h4v.082C37.66 1.044 46.956 10.34 47.918 22H48v4h-.082zM24 29a5 5 0 1 1 1.827-9.656l6.759-6.758 2.828 2.828-6.758 6.759A5 5 0 0 1 24 29z","fill":"#8D6CFF"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"cxrdmparla"},React.createElement("path",{"fill":"#fff","d":"M0 0h48v48H0z"})))]);
}

BrowseFasterIcon.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = BrowseFasterIcon;

BrowseFasterIcon.default = BrowseFasterIcon;
